import { base } from '@/layouts'

export default [
  {
    path: 'you',
    component: base,
    children: [
      {
        name: 'you/support',
        path: 'support',
        component: () => import('@/views/You/Support'),
      },
      {
        name: 'you/menu',
        path: '',
        component: () => import('@/views/You'),
      },
      {
        path: 'legal',
        component: base,
        children: [
          {
            name: 'you/legal/dispute',
            path: 'dispute',
            component: () => import('@/views/You/Legal/Dispute'),
          },
          {
            name: 'you/legal/privacy',
            path: 'privacy',
            component: () => import('@/views/You/Legal/Privacy'),
          },
          {
            name: 'you/legal/tos',
            path: 'tos',
            component: () => import('@/views/You/Legal/TOS'),
          },
          {
            name: 'you/legal',
            path: '',
            component: () => import('@/views/You/Legal'),
          },
        ]
      },
      {
        name: 'you/password',
        path: 'password',
        component: () => import('@/views/You/Password'),
      },
      {
        name: 'you/profile',
        path: 'profile',
        component: () => import('@/views/You/Profile'),
      },
      {
        name: 'you/services',
        path: 'services',
        component: () => import('@/views/You/Services'),
      },
      {
        name: 'you/users',
        path: 'users',
        component: () => import('@/views/You/Users'),
      },
    ],
  },
]